// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1pa_y","footer":"Form_footer__2tMr0"};